import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { ICourseType } from 'src/app/interfaces/country';
import { DataService } from 'src/app/services/data.service';
import { pageKey, toNumber } from 'src/app/services/mapping.service';
import { statusObj } from 'src/app/dummy/status';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthService } from 'src/app/auth/auth.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-add-course-type',
  templateUrl: './add-course-type.component.html',
  styleUrls: ['./add-course-type.component.scss']
})
export class AddCourseTypeComponent implements OnInit {
  @ViewChild("focus", { static: false }) inputRef: ElementRef;

  form: FormGroup;
  code: AbstractControl;
  order: AbstractControl;
  description: AbstractControl;


  constructor(
    public dialogRef: MatDialogRef<AddCourseTypeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public store: List,
    public ds: DataService,
        public auth: AuthStore,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      code: [null, Validators.required],
      description: [null],
      order: [null, Validators.required]
    });
    this.code = this.form.controls['code'];
    this.description = this.form.controls['description'];
    this.order = this.form.controls['order']
  }

  create(f: any, isNew: boolean) {
    if (this.form.valid) {
      this.form.disable()
      const { code, description, order } = f;
      const item: ICourseType = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_date: new Date(),
        created_by: this.ds.userRef().doc(`${this.auth.user.uid}`).ref,
        isDeleted: false,
        status: statusObj.active,
        name: code,
        description: description,
        order: toNumber(order)
      }
      this.store.save(this.ds.courseTypeRef(), item, (success, res) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Course type has been created.', 'Done', { duration: 3000 });
          this.form.reset();
          this.form.enable();
          this.inputRef.nativeElement.focus();
        } else {
          alert(res);
        }
      })
    }

  }

}
